module.exports = __webpack_public_path__ + "static/media/eiffelCorrect.21281a17.png";